import type { PropsWithChildren } from 'react';
import { useFela } from 'react-fela';

import { BackButton } from '../BackButton';
import * as felaRules from './SecretHeader.rules';

export interface SecretHeaderProps extends PropsWithChildren {
    showBackButton?: boolean;
}

export const SecretHeader = ({ children, showBackButton = true }: SecretHeaderProps) => {
    const { css } = useFela({ showBackButton });

    return (
        <div className={css(felaRules.container)}>
            {showBackButton && <BackButton />}
            <div>{children}</div>
        </div>
    );
};
